import React from 'react';
import NSUserAvatar from 'bricks/NSUserAvatar/NSUserAvatar';
import { MentionTypeaheadOption } from '../types';

interface MentionsTypeaheadMenuItemProps {
    index: number;
    isSelected: boolean;
    onClick: () => void;
    onMouseEnter: () => void;
    option: MentionTypeaheadOption;
}

export const MentionsTypeaheadMenuItem: React.FC<MentionsTypeaheadMenuItemProps> = ({
    index,
    isSelected,
    onClick,
    onMouseEnter,
    option,
}) => (
    <li
        className={`d-flex align-items-center p-2 border-0 cursor--pointer NSRichTextEditor__mention-menu-item${
            isSelected ? ' NSRichTextEditor__mention-menu-item--selected' : ''
        }`}
        key={option.key}
        tabIndex={-1}
        ref={option.setRefElement}
        role="option"
        aria-selected={isSelected}
        id={`typeahead-item-${option.id}`}
        onMouseEnter={onMouseEnter}
        onClick={onClick}
        onKeyDown={e => {
            if (e.key === 'Enter') {
                onClick();
            }
        }}
    >
        <NSUserAvatar
            userPicture={option.picture || null}
            size={24}
            radius={12}
            shouldUseIcon
        />
        <span className="text ml-2">{option.name}</span>
    </li>
);
